/*
 * MMX Cart Guard
 * Bundle child pizzas may only exist in the cart as part of a bundle
 * added by the bundle builder blocks (Favorites x4 / Mix & Match / Meet Them All).
 *
 * Rules enforced client-side (server-side twin: pi00a-bundle-guard validation function):
 *  1. A child-pizza line without a `_bundle_group` property is an orphan -> removed.
 *  2. A `_bundle_group` whose child-pizza quantities do not sum to a positive
 *     multiple of 4 is broken -> all its lines are removed.
 *
 * Runs on every page load and after any cart mutation (add/change/update/clear).
 */
(function () {
  "use strict";

  var CHILD_SKUS = ["PI00A-MARG", "PI00A-MISO", "PI00A-QF", "PI00A-SOP"];
  var CART_MUTATION_PATHS = ["/cart/add", "/cart/update", "/cart/change", "/cart/clear"];
  var running = false;

  function isChildItem(item) {
    return CHILD_SKUS.indexOf(item.sku) !== -1;
  }

  function findInvalidKeys(cart) {
    var groups = {};
    var invalid = [];

    cart.items.forEach(function (item) {
      if (!isChildItem(item)) return;
      var group = item.properties && item.properties._bundle_group;
      if (!group) {
        invalid.push(item.key); // orphan direct add
        return;
      }
      groups[group] = (groups[group] || 0) + item.quantity;
    });

    cart.items.forEach(function (item) {
      if (!isChildItem(item)) return;
      var group = item.properties && item.properties._bundle_group;
      if (!group) return;
      var total = groups[group];
      if (total < 4 || total % 4 !== 0) invalid.push(item.key);
    });

    return invalid;
  }

  function clean() {
    if (running) return Promise.resolve();
    running = true;

    return fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;
        var keys = findInvalidKeys(cart);
        if (!keys.length) return null;

        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });

        console.warn("[MMX guard] removing out-of-bundle pizza lines:", keys);

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          // Re-render cart surfaces if we are on the cart page
          if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        });
      })
      .catch(function () { /* network hiccup: server-side validation still blocks checkout */ })
      .then(function () { running = false; });
  }

  // Re-check after any cart mutation done by theme / apps
  if (!window.__mmxGuardFetchPatched) {
    window.__mmxGuardFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
      var p = origFetch.apply(this, args);
      try {
        var path = new URL(url, window.location.origin).pathname;
        var isMutation = CART_MUTATION_PATHS.some(function (m) { return path.indexOf(m) === 0; });
        // Never react to our own /cart/update.js cleanup (guarded by `running`)
        if (isMutation) p.then(function () { setTimeout(clean, 50); }).catch(function () {});
      } catch (e) { /* ignore malformed URLs */ }
      return p;
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { clean(); });
  } else {
    clean();
  }
})();
